import { render, staticRenderFns } from "./config_page.vue?vue&type=template&id=20da2319&scoped=true"
import script from "./config_page.vue?vue&type=script&lang=js"
export * from "./config_page.vue?vue&type=script&lang=js"
import style0 from "./config_page.vue?vue&type=style&index=0&id=20da2319&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20da2319",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20da2319')) {
      api.createRecord('20da2319', component.options)
    } else {
      api.reload('20da2319', component.options)
    }
    module.hot.accept("./config_page.vue?vue&type=template&id=20da2319&scoped=true", function () {
      api.rerender('20da2319', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/config_page.vue"
export default component.exports